export function departmentComparator(
  valA: any,
  valB: any,
  _nodeA,
  _nodeB,
  isInverted
): number {
  const valAEmpty = !valA || !valA.name || valA.name.length === 0;
  const valBEmpty = !valB || !valB.name || valB.name.length === 0;

  if (valAEmpty && valBEmpty) {
    return 0;
  }

  if (valAEmpty) {
    return isInverted ? -1 : 1;
  } else if (valBEmpty) {
    return isInverted ? 1 : -1;
  }

  return valA.name.localeCompare(valB.name);
}
